import { useContext } from 'react';
import AuthContext from '../contexts/JWTAuthContext';

const useUserContext = () => useContext(AuthContext);

export default useUserContext;